import React, { useContext, useEffect } from "react";
import { routeDatas } from "../../Datas/RouteDatas/MainRoutes";
import { Link, NavLink } from "react-router-dom";
import logo from "./../../Imgs/brand_logo.png";
import minilogo from "./../../Imgs/favicon.png";
import { useSiteData } from "../../Contexts/SiteContext";
import { useAuthContext } from "../../Contexts/AuthContext";

const Navbar = () => {
  const { isDark, setIsDark } = useSiteData();
  const { user, logout, isAdmin, isLoggedin } = useAuthContext();
  function switchMode(value) {
    localStorage.setItem("theme", value);
    setIsDark(value);
  }
  return (
    <div className="w-full md-navbar z-50 capitalize m-0">
      <div className="w-full md:container mx-auto p-1">
        <nav className="flex justify-between flex-col md:flex-row text-sm md:text-lg dark:dark-text">
          <div className=" md:h-auto md:w-1/5 rounded fixed top-0 left-0 w-screen md:relative  bg-front dark:dark-bg-front md:inline-block flex flex-row justify-between items-center border-b-2 border-b-gray-200 md:border-b-0 py-2 ">
            <div>
              <Link className="w-auto h-full hidden  md:inline-block" to="/">
                <img
                  className=" h-full my-auto "
                  src={logo}
                  alt="Thanos eShop LOGO"
                />
              </Link>
              <Link to="/">
                <img
                  className="my-auto h-12 rounded-full inline-block md:hidden mx-3"
                  src={minilogo}
                  alt="Thanos eShop LOGO"
                />
              </Link>
            </div>
            <div className="md:hidden">
              <span className="inline-block text-sm md:text-lg mx-2">
                <button
                  className="ml-1 rounded-full ring-1 ring-orange-500 w-10 h-10"
                  onClick={() => switchMode(isDark ? "" : "dark")}
                >
                  {isDark ? (
                    <i className="fa fa-sun" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-moon" aria-hidden="true"></i>
                  )}
                </button>
              </span>
            </div>
          </div>
          <ul className="w-auto  grid grid-flow-col items-center gap-4 overflow-x-scroll no-scrollbar py-1">
            {routeDatas.map(
              (route, i) =>
                (route.isNavbarItem ||
                  (route.route === "/dashboard" && isLoggedin) ||
                  (route.route === "/login" && !isLoggedin)) && (
                  <li key={i} className="text-sm md:text-lg mx-2 inline-block">
                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "nav-item active font-bold"
                          : "nav-item nav-item-hover"
                      }
                      to={route.route}
                    >
                      <i
                        className={
                          route.icon +
                          " md:text-md md:hidden lg:inline-block text-lg inline-block"
                        }
                        title={route.title}
                        aria-hidden="true"
                      ></i>
                      <span className="ml-1">{route.title}</span>
                    </NavLink>
                  </li>
                )
            )}
            <li
              className="hidden md:inline-block text-sm md:text-lg mx-2 "
              title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              <button
                className="ml-1 rounded-full ring-1 ring-orange-500 w-10 h-10"
                onClick={() => switchMode(isDark === "dark" ? "light" : "dark")}
              >
                {isDark === "dark" ? (
                  <i className="fa fa-sun" aria-hidden="true"></i>
                ) : (
                  <i className="fa fa-moon" aria-hidden="true"></i>
                )}
              </button>
            </li>
            {isLoggedin && (
              <li
                className="hidden md:inline-block text-sm md:text-lg mx-2 "
                title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
              >
                <button className="ml-1 site-btn px-3 py-2" onClick={logout}>
                  {" "}
                  <i
                    className="fa fa-sign-out mr-2 hidden md:inline-block"
                    aria-hidden="true"
                  ></i>{" "}
                  <span> Logout</span>
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
